import { defineMessage } from 'services/localization';

export const messages = {
    learnMoreTitle: defineMessage('learn_more'),
    getInTouchTitle: defineMessage('get_in_touch'),
    menuItemNameKnowledgeBase: defineMessage('knowledge_base'),
    menuItemNameHowToVideos: defineMessage('howto_videos'),
    menuItemNameWebSite: defineMessage('approvalmax_website'),
    menuItemNameGetMobileApp: defineMessage('get_the_mobile_app'),
    menuItemNameContactSupport: defineMessage('contact_support'),
    menuItemNameContactSales: defineMessage('contact_sales_2'),
};
